import API from 'utils/api';
import getFormattedValues, { formatReceived, hasFiles } from 'utils/formatValues';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = 'configuraciones/periodos-fiscales';
export const estatusURI = 'configuraciones/actualizar-estado-periodo-fiscal';

const getValuesAndConfig = (values) => {
  const files = ['documento_anexo_PDF', 'documento_anexo_word'];
  const config = hasFiles(values, files) ? {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  } : {};
  // eslint-disable-next-line no-param-reassign
  values.periodo = values.periodo.format('YYYY');
  const formattedValues = getFormattedValues(values, {
    files,
    formData: config.headers,
    clean: false,
  });
  return [formattedValues, config];
};

/**
 * GET Periodos Fiscales
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getPeriodosFiscales = async (params) => {
  try {
    const response = await API.get(baseURI, { params });

    const res = response.data.map((periodo) => ({
      ...periodo,
      descripcion: `${periodo.periodo}`,
    }));

    return formatReceived(res);
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Periodo Fiscal
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getPeriodoFiscal = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Periodo Fiscal
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postPeriodoFiscal = async (values) => {
  try {
    const response = await API.post(baseURI, ...getValuesAndConfig(values));
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Periodo Fiscal
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchPeriodoFiscal = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, ...getValuesAndConfig(values));
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Periodo Fiscal
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deletePeriodoFiscal = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Actualizar Estatus
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchActualizarEstatusPeriodo = async (periodoId, estadoId) => {
  try {
    const response = await API.patch(`${estatusURI}/${periodoId}/${estadoId}`);
    onSuccess(response, 'Editado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
